import { createContext } from "react";
import loads from "./init-loads";
export default createContext({
  weather: {},
  loads
});
